import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import useAuthStore from "../../../services/AuthStore";
import { Delete, Edit } from "@mui/icons-material";

export default function Students() {
  const { getStudents, getGroups } = useAuthStore();
  const [students, setStudents] = useState([]);
  const [groups, setGroups] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [currentStudent, setCurrentStudent] = useState({
    user_id: null,
    lastname: "",
    name: "",
    surname: "",
    email: "",
    phone: "",
    group_id: "",
  });
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    getStudents()
      .then(newStudents => setStudents(newStudents))
      .catch(error => console.error("Ошибка при получении студентов:", error));
  }, [getStudents]);

  useEffect(() => {
    getGroups()
      .then(newGroups => setGroups(newGroups))
      .catch(error => console.error("Ошибка при получении групп:", error));
  }, [getGroups]);

  const handleOpenDialog = (
    student = {
      user_id: null,
      lastname: "",
      name: "",
      surname: "",
      email: "",
      phone: "",
      group_id: "",
    },
  ) => {
    setCurrentStudent(student);
    setIsEditing(!!student.user_id);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setCurrentStudent({
      user_id: null,
      lastname: "",
      name: "",
      surname: "",
      email: "",
      phone: "",
      group_id: "",
    });
  };

  const handleSaveStudent = () => {
    if (isEditing) {
      setStudents(prev =>
        prev.map(student =>
          student.user_id === currentStudent.user_id ? currentStudent : student,
        ),
      );
    } else {
      setStudents(prev => [
        ...prev,
        {
          ...currentStudent,
          user_id: prev.length ? prev[prev.length - 1].user_id + 1 : 1,
        },
      ]);
    }
    handleCloseDialog();
  };

  const handleDeleteStudent = id => {
    setStudents(prev => prev.filter(student => student.user_id !== id));
  };

  const columns = [
    { field: "user_id", headerName: "ID", width: 90 },
    { field: "lastname", headerName: "Фамилия", width: 150 },
    { field: "name", headerName: "Имя", width: 150 },
    { field: "surname", headerName: "Отчество", width: 150 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "phone", headerName: "Телефон", width: 150 },
    {
      field: "group_id",
      headerName: "Группа",
      width: 150,
      renderCell: params =>
        groups.find(group => group.id === params.value)?.group_name ||
        "Не указана",
    },
    {
      field: "actions",
      headerName: "Действия",
      width: 200,
      renderCell: params => (
        <Box>
          <Button
            size="small"
            variant="contained"
            onClick={() => handleOpenDialog(params.row)}>
            <Edit />
          </Button>
          <Button
            size="small"
            color="error"
            variant="contained"
            onClick={() => handleDeleteStudent(params.row.user_id)}
            style={{ marginLeft: 8 }}>
            <Delete />
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Typography variant="h6" style={{ marginBottom: 16 }}>
        Управление студентами
      </Typography>
      <Button
        variant="contained"
        onClick={() => handleOpenDialog()}
        style={{ marginBottom: 16 }}>
        Добавить нового студента
      </Button>
      <Box sx={{ height: 400, width: "100%" }}>
        <DataGrid
          rows={students}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
        />
      </Box>

      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>
          {isEditing ? "Редактировать студента" : "Добавить студента"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Фамилия"
            type="text"
            fullWidth
            value={currentStudent.lastname}
            onChange={e =>
              setCurrentStudent({ ...currentStudent, lastname: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Имя"
            type="text"
            fullWidth
            value={currentStudent.name}
            onChange={e =>
              setCurrentStudent({ ...currentStudent, name: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Отчество"
            type="text"
            fullWidth
            value={currentStudent.surname}
            onChange={e =>
              setCurrentStudent({ ...currentStudent, surname: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            value={currentStudent.email}
            onChange={e =>
              setCurrentStudent({ ...currentStudent, email: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Телефон"
            type="text"
            fullWidth
            value={currentStudent.phone}
            onChange={e =>
              setCurrentStudent({ ...currentStudent, phone: e.target.value })
            }
          />
          <Select
            fullWidth
            value={currentStudent.group_id}
            onChange={e =>
              setCurrentStudent({ ...currentStudent, group_id: e.target.value })
            }>
            {groups?.map(group => (
              <MenuItem key={group.id} value={group.id}>
                {group.group_name}
              </MenuItem>
            ))}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Отмена</Button>
          <Button onClick={handleSaveStudent} variant="contained">
            Сохранить
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
